<template>
  <div class="view-entry-detail bg-light min-h-screen">
    <v-container v-if="!loading" fluid class="pa-4">
      <!-- Encabezado compacto: regresar + tipo + chips en una sola barra -->
      <div class="glass-header d-flex align-center flex-wrap px-4 py-2 mb-3">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small class="mr-2" v-bind="attrs" v-on="on"
              @click="hasHistory ? $router.back() : $router.push({ name: 'DiaryBook' })">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>Regresar al Libro Diario</span>
        </v-tooltip>
        <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
        <h1 class="text-h6 font-weight-black primary--text tracking-tight mb-0 mr-4">
          {{ dataEntry.diary_book_type_name }}
        </h1>
        <v-chip color="primary lighten-5" text-color="primary" class="font-weight-black mr-2 my-1" small label>
          {{ dataEntry.diary_book_code }}
        </v-chip>
        <v-chip color="grey lighten-4" text-color="grey darken-3" class="font-weight-bold mr-2 my-1" small label
          outlined>
          <v-icon left small>mdi-office-building</v-icon>
          {{ dataEntry.business_unit_description }}
        </v-chip>
        <v-chip color="blue-grey lighten-5" text-color="blue-grey darken-3" class="font-weight-bold my-1" small
          label outlined>
          <v-icon left small>mdi-calendar</v-icon>
          {{ getDate(dataEntry.effective_date) }}
        </v-chip>
        <v-tooltip v-if="dataEntry.user_fullname" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip color="indigo lighten-5" text-color="indigo darken-3" class="font-weight-bold ml-2 my-1" small
              label outlined v-bind="attrs" v-on="on">
              <v-icon left small>mdi-account-edit</v-icon>
              {{ dataEntry.user_fullname }}
            </v-chip>
          </template>
          <span>Registrado por {{ dataEntry.user_fullname }}<template v-if="dataEntry.created_date">
            el {{ getDateTime(dataEntry.created_date) }}</template></span>
        </v-tooltip>
      </div>

      <!-- Detail Component Container -->
      <v-row justify="center" no-gutters>
        <v-col cols="12">
          <v-card class="rounded-xl shadow-premium overflow-hidden border-light" elevation="0">
            <PostAccounting v-if="pre_accounting_computed.length > 0" compact :cant_edit="false" :search_names="true"
              :order_item_entries="pre_accounting_computed" :total_amount="debitoAndCredito.credito"
              :transaction_amounts="dataEntry.amounts || []"
              :total_amount_base="dataEntry.business_unit_currency_code + '$' + currencyFormat(debitoAndCredito.currency_base_amount)"
              :totalAmountBase="debitoAndCredito.currency_base_amount"
              :base_currency_code="dataEntry.business_unit_currency_code || 'USD'"
              :show_credits="true" :accounting_date="dataEntry.effective_date"
              :business_unit_id="dataEntry.business_unit_id" :diary_book_code="dataEntry.diary_book_code || 'N/A'" />
          </v-card>
        </v-col>
      </v-row>
      <v-row>

        <v-col cols="12" md="3" v-if="dataEntry.note" class="text-md-right">
          <div class="note-container pa-4 rounded-xl border-dashed">
            <div class="d-flex align-center justify-md-end mb-1">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-note-text</v-icon>
              <span class="text-overline font-weight-black grey--text text--darken-1">OBSERVACIONES</span>
            </div>
            <p class="text-body-2 mb-0 grey--text text--darken-3 font-italic">
              "{{ dataEntry.note }}"
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Loading State -->
    <v-row v-else justify="center" align="center" class="fill-height min-h-screen">
      <v-col cols="12" md="10" class="pa-12">
        <v-skeleton-loader type="article, card-heading, table-heading, table-thead, table-tbody, actions"
          class="rounded-xl"></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.view-entry-detail {
  background-color: #f8fafc !important;
}

.bg-light {
  background-color: #f8fafc !important;
}

.glass-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 28px;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.05);
}

.shadow-premium {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 20px 25px -5px rgba(0, 0, 0, 0.05) !important;
}

.border-light {
  border: 1px solid #e2e8f0 !important;
}

.border-dashed {
  border: 1.5px dashed #cbd5e1 !important;
}

.note-container {
  background-color: #f1f5f9;
  max-width: 400px;
  display: inline-block;
  text-align: left;
}

.tracking-tight {
  letter-spacing: -0.05em;
}

.min-h-screen {
  min-height: 100vh;
}
</style>
<script>
import moment from "moment";
import PreAccounting from "@/components/Accounting/PreAccounting.vue";
import PostAccounting from "@/components/Accounting/PostAccounting.vue";
//import SearchHeader from "../../components/SearchHeader.vue";
export default {
  data: () => ({
    page: 1,
    dataEntry: {},
    flatDetails: [],
    hasHistory: false,
    pageCount: 0,
    search: "",
    loading: false,
    sortBy: "entity_id",
    sortDesc: false,
    headers: [
      // { text: "Entidad", value: "entity_name" },
      { text: "Concepto", value: "note", width: "15%" },
      {
        text: "Departamento",
        value: "department_id",

        align: "start",
      },
      {
        text: "Location",
        value: "location_description",
        align: "center",
      },
      //  { text: "Fecha", value: "created_date", width: "10%", align: "center" },


      { text: "Cuenta contable", value: "chart_of_account_name" },

      { text: "Tras Deb", value: "transDebito", align: "end" },
      { text: "Tras Cred", value: "transCredito", align: "end" },
      { text: "Debito", value: "debito", align: "end" },
      { text: "Credito", value: "credito", align: "end" },
    ],
  }),
  created() {
    this.getData();
    this.getFlatDetails();
  },
  mounted() {
    this.hasHistory = window.history.length > 2;
  },
  components: {
    PreAccounting,
    PostAccounting
  },
  computed: {
    pre_accounting_computed() {
      // Usa flatDetails (de accounting/show_diary_book_details) en lugar de
      // diary_book_details del view. Ese endpoint devuelve base_amount por línea
      // (= amount × currency_rate guardado), con lo que derivamos la tasa exacta:
      //   currency_rate = base_amount / amount
      // Esto es correcto incluso para asientos de apertura anual donde cada cuenta
      // tiene una tasa promedio ponderada distinta para la misma moneda y dirección.
      if (!this.flatDetails || this.flatDetails.length === 0) return [];
      return this.flatDetails.map((item) => {
        const amount = parseFloat(item.amount) || 0;
        const baseAmount = parseFloat(item.base_amount) || 0;
        const currencyRate = amount !== 0 ? baseAmount / amount : 1;
        return {
          item_id: item.entity_id || item.note,
          item_name: item.entity_name || item.note,
          entity_name: item.entity_name,
          currency_code: item.currency_code,
          order_chart_of_accounts: [{
            chart_of_account_id: item.chart_of_account_id,
            chart_of_account_code: item.chart_of_account_code,
            chart_of_account_name: null,
            category_id: item.category_id,
            subcategory_id: item.subcategory_id,
            location_id: item.location_id || null,
            department_id: item.department_id || 0,
            entry_type_id: item.entry_type_id,
            amount: amount,
            entity_name: item.entity_name,
            currency_id: item.currency_id,
            currency_code: item.currency_code,
            currency_rate: currencyRate,
          }]
        };
      });
    },
    debitoAndCredito() {
      // La vista diary_book_with_details_with_amounts ya calcula en el servidor:
      //   base_debit  = SUM(amount * currency_rate) WHERE entry_type_id = 1
      //   base_credit = SUM(amount * currency_rate) WHERE entry_type_id = 2
      // Esto es correcto incluso cuando hay múltiples tasas distintas para la misma
      // moneda/dirección (caso de la apertura anual, donde cada cuenta tiene su propia
      // tasa promedio ponderada). Usar estos valores evita cualquier recálculo incorrecto
      // en el frontend.
      const debito = parseFloat(this.dataEntry.base_debit || 0);
      const credito = parseFloat(this.dataEntry.base_credit || 0);

      return {
        debito,
        credito,
        currency_base_amount: debito,
        arrayCurrency: [],
      };
    },
  },
  methods: {
    getDateTime(date) {
      return moment(date).format("DD-MM-YYYY hh:mm A");
    },
    getDate(date) {
      let newDate = moment(date).format("DD-MM-YYYY").toString();
      return newDate;
    },

    currencyFormat(value) {
      if (!value && value !== 0) return '0.00'
      return new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    },
    async getFlatDetails() {
      const id = parseInt(this.$route.params.id);
      try {
        const response = await this.api_Post("accounting/show_diary_book_details", {
          diaryBookId: id,
          location_access: [],
          page: 1,
          itemsPerPage: 9999,
        });
        const result = await response.json();
        this.flatDetails = result.data || [];
      } catch (error) {
        console.error("Error loading flat diary book details:", error);
        this.flatDetails = [];
      }
    },
    async getData() {
      this.loading = true;
      let id = this.$route.params.id;

      let filters = " and diary_book_id=" + id + " ";
      try {
        const responseRequest = await this.api_Post("accounting/diary_book", {
          filtros: filters,
        });
        let data = await responseRequest.json();
        if (data && data.length > 0) {
          this.dataEntry = data[0];
          const entryLocations = this.dataEntry.locations || [];
          const userLocations = this.$store.state.auth.locations || [];
          const hasAccess =
            entryLocations.length === 0 ||
            entryLocations.some((el) =>
              userLocations.some((ul) => ul.id === el.location_id || ul.value === el.location_id)
            );
          if (!hasAccess) {
            this.loading = false;
            this.$router.replace({ name: "NoAcces" });
            return;
          }
        } else {
          this.dataEntry = {};
          console.warn("No diary book entry found for ID:", id);
        }
      } catch (error) {
        console.error("Error loading diary book:", error);
        this.dataEntry = {};
      } finally {
        this.loading = false;
      }
      //   function agruparYSumar(data) {
      //     const agrupado = {};

      //     data.forEach(item => {
      //       const key = [
      //         item.chart_of_account_id,
      //         item.entry_type_id,
      //         item.department_id,
      //         item.category_id,
      //         item.subcategory_id
      //       ].join('|');

      //       if (!agrupado[key]) {
      //         agrupado[key] = {
      //           ...item,
      //           amount: item.amount,
      //           departments: [...(item.departments || [])]
      //         };
      //       } else {
      //         agrupado[key].amount += item.amount;

      //         // Unificar departments únicos por department_id
      //         const existingDeptIds = new Set(agrupado[key].departments.map(d => d.department_id));
      //         (item.departments || []).forEach(dep => {
      //           if (!existingDeptIds.has(dep.department_id)) {
      //             agrupado[key].departments.push(dep);
      //           }
      //         });
      //       }
      //     });

      //     return Object.values(agrupado);
      //   }
      //  const data_agrupada =   agruparYSumar(this.dataEntry.diary_book_details);
      //  this.dataEntry.diary_book_details=data_agrupada;
      this.loading = false;
    },
  },
};
</script>
